import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10 * (props.wx ?? 1)}
    height={33 * (props.hx ?? 1)}
    viewBox="0 0 10 33"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.736 3.151c-.228-.409-.643-.838-1.277-1.247-.543-.35-1.241-.89-1.975-.904-.618-.012-1.38.635-1.806.89-.983.586-1.633.845-2.261 1.566-.946 1.085-.012 6.5.176 7.247.085.339.201.607.324.842.197.377.281.75.341 1.316.228 2.14.28 4.242.27 6.844-.011 3.15-.137 4.975-.39 7.38-.306 2.923-.363 4.749.405 4.813.464.038 1.357-1.807 2.29-4.771.926-2.945 1.87-8.017 2.719-13.709.181-1.217.557-1.858.84-2.723.173-.527.311-1.132.447-1.818.438-2.214.596-4.47-.104-5.726z"
    />
  </svg>
);
export default SvgNormal;
